import $ from 'jquery';
import 'jquery-match-height';

$(window).on('load', function () {
    let $targets = $('.match-height');

    if ($targets.length) {
        let $targetsNotByRow = $targets.filter('.not-by-row');

        $targetsNotByRow.matchHeight({
            byRow: false
        });

        $targets.filter(':not(.not-by-row)').matchHeight();
    }

    /**
     * Fix layout blocks in IE9
     */
    if ($('html').hasClass('ie9')) {
        console.log('match block heights in ie9');

        $('.page-blocks .block, .block.text-image .flex > *').matchHeight();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/MatchHeight.js